import { render } from "./VideoDetail.vue?vue&type=template&id=725050e1&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"

import "./VideoDetail.vue?vue&type=style&index=0&id=725050e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725050e1"]])

export default __exports__